import React from 'react';
import { useSelector } from 'react-redux';

import { Sidecar as SidecarBase } from '@swf/poker';

import { usePokerSundayMillionWidget } from '../../../../model';

import Content from './Content/Content';
import styles from './Sidecar.scss';

export const Sidecar: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const tournament = useSelector(widgetSelect.getTournament);

  const { formattedState: state, tags, imageUrl, fallbackImageUrl } = tournament;

  return (
    <div className={styles.root}>
      <SidecarBase.Card
        tags={tags}
        state={state}
        imageUrl={imageUrl}
        fallbackImageUrl={fallbackImageUrl}
        className={styles.card}
      />
      <div className={styles.info}>
        <Content />
        <SidecarBase.LobbyButton tournament={tournament} />
      </div>
    </div>
  );
};

export default Sidecar;
